export enum Lang {
  English = 'en',
  Arabic = 'ar',
}
